import React from 'react';
import { makeStyles } from '@material-ui/core/styles'
import Layout from '../../../layout';
import TextWithImg from "./../../common/TextWithImg";
import Button from '@material-ui/core/Button';
import RegisterStep from './registerStep';
import CarVideo from './carVideo';
import Accordion from './accordion';

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        [theme.breakpoints.up('md')]: {
            width: '100%',
        },
        [theme.breakpoints.down('sm')]: {
            width: '100%',
        },
    },
    button: {
        margin: "10px 0px",
        backgroundColor: theme.palette.light.type2,
        color: "white",
        borderColor: theme.palette.light.type2,
        borderRadius: "0 15px 15px 15px",
        "&:active": {
            backgroundColor: theme.palette.light.type2,
        },
        "&:hover": {
            backgroundColor: theme.palette.light.type2,
        },
    },
}))


export default function Index() {

    const classes = useStyles()


    return (
        <Layout>
            <div className={classes['root']}>
                <TextWithImg data={data} />
                <Button
                    variant="contained"
                    className={classes.button}
                    style={{ padding: "10px 50px" }}
                    href={"https://pouyan.ebgo.ir/GetBourseCode/getInformation"}
                    target="_blank"
                >
                    ثبت نام خرید خودرو
                </Button>
                <RegisterStep />
                <CarVideo/>
                <Accordion/>
            </div>
        </Layout>
    )
}

let data = {
    title: " ثبت نام خودرو",
    content: `
    شرایط خاص اقتصادی سال های اخیر که به ارز چند نرخی منجر شد، همه بازارها و بنگاه های اقتصادی را با چالش های بزرگی مواجه کرد؛ صنعت خودروسازی از جمله بزرگترین ضررکنندگان این وضعیت بود که با حذف ارز ترجیحی برای خرید قطعات و عدم تغییر قیمت محصولات به زیان دهی رسیدند. با رشد مداوم نرخ ارز و عدم اجازه رشد مناسب نرخ محصولات در کارخانه، سود هنگفتی نصیب دلالان و یا خریداران خوش شانس قرعه کشی ها می شد. تنها راه بهبود وضعیت برای خودروسازان و مصرف کنندگان واقعی، حذف واسطه ها و قیمت گذاری دستوری است، تابستان 1401 بالاخره وزارت صمت با وجود مخالفت های شدید برای عرضه خودرو از طریق سازوکار بورس کالا، با فرآهم شدن زیرساخت های لازم در جهت تحقق این کار موافقت خود را اعلام کرد؛ تا خرید و فروش این کالا با بالاترین شفافیت ممکن و رقابت بین خریداران و فروشندگان امکان پذیر شود.
    `,
    src: "caaaar.png"
}

